import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { Box, LinearProgress } from "@mui/material";

function AnimateLoading() {
  const location = useLocation();
  const [width, setWidth] = useState(0);
  const animateTimeoutRef = useRef(null);
  const stopAnimateTimeoutRef = useRef(null);

  const stopAnimate = useCallback(() => {
    clearTimeout(animateTimeoutRef.current);
    stopAnimateTimeoutRef.current = setTimeout(() => {
      setWidth(0);
    }, 300);
  }, []);

  const animate = useCallback(() => {
    animateTimeoutRef.current = setTimeout(() => {
      setWidth((prevWidth) => {
        const newWidth = prevWidth + 10;
        if (newWidth <= 100) {
          // Continue animation
          setTimeout(() => animate(), 30);
          return newWidth;
        } else {
          // Stop animation
          stopAnimate();
          return 100;
        }
      });
    }, 30);
  }, [stopAnimate]);

  // Effect to handle route changes (replaces componentDidUpdate)
  useEffect(() => {
    animate();
  }, [location.pathname, animate]);

  // Cleanup effect (replaces componentWillUnmount)
  useEffect(() => {
    return () => {
      if (stopAnimateTimeoutRef.current) {
        clearTimeout(stopAnimateTimeoutRef.current);
      }
      if (animateTimeoutRef.current) {
        clearTimeout(animateTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Box className="header-progress-bar" style={{ height: "3px", width: "100%" }}>
      {width > 0 && (
        <LinearProgress variant="determinate" value={width} style={{ height: "3px" }} />
      )}
    </Box>
  );
}

export default AnimateLoading;
